import {Component, OnInit} from '@angular/core';
import {NavBarService} from '../../../services/nav-bar/nav-bar.service';
import {TranslatableString} from '../../../models/TranslatableString';
import {BaseHttpService} from '../../../services/base-http/base-http.service';
import {BASE_URL, MEDIA_URL} from '../../../shared/constants';

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss']
})
export class NewsComponent implements OnInit {
  allNews: {
    pictureUrl: string,
    title: TranslatableString,
    description: TranslatableString,
    date: string,
    link: string
  }[];
  
  constructor(private nav: NavBarService, private httpService: BaseHttpService) {
    
    this.allNews = [];
    this.httpService.getNews().subscribe((data) => {
      data.forEach((el) => {
        this.allNews.push({
          pictureUrl: MEDIA_URL + el.picture,
          title: new TranslatableString(el.title, el.title_en, el.title_bg, el.title_ru),
          description: new TranslatableString(el.text, el.text_en, el.text_bg, el.text_ru),
          date: el.date,
          link: el.link
        });
      });
    });
  }
  
  ngOnInit() {
    setTimeout(() => {
      this.nav.deselectAll();
      this.nav.newsSelected = true;
    }, 0);
  }
}
